/** Custom validators are stored here */
import { AbstractControl, ValidatorFn } from '@angular/forms';

export const regexValidator = (regex: RegExp, customName?: string): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {

        const isValid = regex.test(control.value);

        const output = {}
        output[customName || 'regexPattern'] = { value: control.value };

        return isValid ? null : output;
    };
}